import { render, staticRenderFns } from "./TrackingInfo.vue?vue&type=template&id=06a031a6"
import script from "./TrackingInfo.vue?vue&type=script&lang=js"
export * from "./TrackingInfo.vue?vue&type=script&lang=js"
import style0 from "./TrackingInfo.vue?vue&type=style&index=0&id=06a031a6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports